import React from 'react'
import yup from 'yup'
import Form from 'react-formal'
import NavigationBar from '../Commons/NavigationBar'
import ProfilePicture from '../Commons/ProfilePicture'
import RadioGroup from 'react-radio-group'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { hashHistory } from 'react-router'
import moment from 'moment'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import _ from 'lodash'
import SpecialConditions from './SpecialConditions'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

var patientSchema = yup.object({
  tipoDocumento: yup.string().nullable().required('Seleccione el tipo de documento'),
  numeroDocumento: yup.string().min(4, 'El numero de identificación debe tener mínimo 4 caracteres').required('Ingrese el número de identificación'),
  nombres: yup.string().min(2, 'El nombre debe tener mínimo 2 caracteres').required('Ingrese el nombre completo'),
  apellidos: yup.string().min(2, 'El apellido debe tener mínimo 2 caracteres').required('Ingrese los apellidos'),
  email: yup.string().email('Ingrese un email valido').required('Ingrese el email'),
  telefono: yup.string().min(5, 'El número telefono debe tener mínimo 5 caracteres').required('Ingrese el número de télefono'),
  celular: yup.string().min(10, 'El número de celular debe tener mínimo 10 caracteres').required('Ingrese el número de celular'),
  direccion: yup.string().min(6, 'La dirección debe tener mínimo 6 caracteres').required('Ingrese la dirección'),
  barrio: yup.string('el barrio debe ser un texto').min(3, 'El barrio debe tener mínimo 3 caracteres').required('Ingrese el barrio'),
  ciudad: yup.string().nullable().required('Ingrese el ciudad de residencia'),
  ocupacion: yup.string().min(4, 'La ocupación debe tener mínimo 4 caracteres').required('Ingrese la ocupacion'),
  estadoCivil: yup.string().nullable().required('Seleccione el estado civil'),
  entidad: yup.string().nullable().required('Seleccione la entidad médica'),
  tipoAfiliacion: yup.string().nullable().required('Seleccione el tipo de afiliación'),
  fechaNacimiento: yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/, 'Ingrese una fecha valida con formato (DD/MM/AAAA)').required('Ingrese la fecha de nacimiento'),
  nivelEducativo: yup.string().nullable().required('Seleccione el nivel educativo'),
  parentezco: yup.string().min(3, 'El parentesco debe tener mínimo 3 caracteres'),
  tipoDocumentoAcomp: yup.string().nullable(),
  numeroDocumentoAcomp: yup.string().min(4, 'El numero de identificación debe tener mínimo 4 caracteres'),
  nombresAcomp: yup.string().min(2, 'El nombre debe tener mínimo 2 caracteres'),
  apellidosAcomp: yup.string().min(2, 'El apellido debe tener mínimo 2 caracteres'),
  telefonoAcomp: yup.string().min(5, 'El número telefono debe tener mínimo 5 caracteres'),
  celularAcomp: yup.string().min(10, 'El número de celular debe tener mínimo 10 caracteres')
})

export default class PatientForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ selectedValue: 'N', loader: 'all', classForm: 'form-person-info hide', selectedGender: 'f', showGuardianFields: false, file: '', imagePreviewUrl: '', model: {}, emailInfo: {}, marcaciones: {}, guardian: {}, patientImage: '', dirty: false, grupo: '', eps: '', type: '', groupClass: 'select list', epsClass: 'select list', typeClass: 'select list', isUpdate: this.props.isUpdate, patientId: this.props.patientId })
  }

  componentWillMount () {
    this.loadPatientData()
    this.findData()
  }
  tipoDocumentoProcess (arg) {
    switch (arg) {
      case 'Cédula':
        return 'CC'
      case 'Pasaporte':
        return 'PP'
      case 'Cédula Extranjería':
        return 'CE'
      case 'Tarjeta de identidad':
        return 'TI'
      case 'Otro':
        return 'RC'
    }
  }
  estadoCivilProcess (arg) {
    switch (arg) {
      case 'Soltero(a)':
        return 'Soltero'
      case 'Casado(a)':
        return 'Casado'
      case 'Viudo(a)':
        return 'Viudo'
      case 'Separado(a)':
        return 'Divorciado'
      case 'Con pareja':
        return 'Unión libre'

    }
  }
  EPSProcess (arg) {
    let eps = this.state.epsSelect
    let objeps = _.find(eps, {'nombre': arg})
    return _.isEmpty(arg) || _.isEmpty(objeps) ? '' : objeps._id
  }
  GrupoProcess (arg) {
    let grupos = this.state.grupos
    let objgrupo = _.find(grupos, {'nombre': arg})
    return _.isEmpty(arg) || _.isEmpty(objgrupo) ? '' : objgrupo._id
  }
  tipoAfiliacionProcess (arg) {
    let tipos = this.state.types
    let objtipo = _.find(tipos, {'nombre': arg})
    return _.isEmpty(arg) || _.isEmpty(objtipo) ? '' : objtipo._id
  }
  loadImage () {
    let endpoint = `https://core.sicor.com.co:3101/paciente?identificacion=${this.props.patientId}`
    request
    .get(endpoint)
    .set('Authorization', `Bearer ${getToken()}`)
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err) {
        err
      } else {
        if (_.isEmpty(res.body[0])) {
          this.setState({
            isUpdate: false,
            loader: 'hide',
            classForm: 'form-person-info'})
          this.refs.container.warning(`El paciente con el numero de documento ${this.state.patientId}. No existe en la base de datos del Sicor.`, '', {
            timeOut: 30000,
            closeButton: true
          })
        } else {
          let endpoint = `https://core.sicor.com.co:9000/${res.body[0].imagenId}`
          request
          .get(endpoint)
          .set('Authorization', `Bearer ${getToken()}`)
          .use(NoCache)
          // .set('Accept', 'application/json')
          .end((err, res) => {
            if (err) throw (err)
            this.setState({patientImage: res.text, imagePreviewUrl: res.text})
          })
        }
      }
    })
  }
  loadPatientData () {
    if (this.state.patientId) {
      let endpoint = `api/v1/patient/find?numeroDocumento=${this.state.patientId}`
      request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        // console.log(res.body[0])
        if (!_.isEmpty(res.body[0])) {
          res.body[0].fechaNacimiento = moment(res.body[0].fechaNacimiento).format('DD/MM/YYYY')
          this.setState({muerto: res.body[0].muerto, loader: 'hide', classForm: 'form-person-info', model: res.body[0], selectedGender: res.body[0].genero, imagePreviewUrl: res.body[0].image, patientImage: res.body[0].image, grupo: res.body[0].grupo[0]._id, eps: res.body[0].eps[0]._id, type: res.body[0].type[0]._id })
          if (this.state.model.parentezco !== '') {
          //  this.setState({ selectedValue: 'Y', showGuardianFields: true })
          } else {
            // this.setState({ selectedValue: 'N', showGuardianFields: false })
          }
        } else if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontro el paciente', '', {
            closeButton: true
          })
        }  else if (_.isEmpty(res.body[0])) {
          let endpoint = `https://core.sicor.com.co:3101/paciente?identificacion=${this.props.patientId}`
          request
          .get(endpoint)
          .set('Authorization', `Bearer ${getToken()}`)
          .use(NoCache)
          .set('Accept', 'application/json')
          .end((err, res) => {
            if (err) {
              err
            } else {
              if (_.isEmpty(res.body[0])) {
                this.setState({
                  isUpdate: false,
                  loader: 'hide',
                  classForm: 'form-person-info',
                  model: {
                    numeroDocumento: this.props.patientId}
                  })
                this.refs.container.warning(`El paciente con el numero de documento ${this.state.patientId}. No existe en la base de datos del Sicor.`, '', {
                  timeOut: 30000,
                  closeButton: true
                })
              } else {
                this.refs.container.success('El paciente existe en la base de datos del Sicor, debes completar la informacion restante para guardar.', '', {
                  timeOut: 30000,
                  closeButton: true
                })
                let gender = (res.body[0].genero).toLowerCase()
                let email = _.isEmpty(res.body[0].email) ? '' : res.body[0].email
                let telefono = _.isEmpty(res.body[0].telefono) ? '' : res.body[0].telefono
                let celular = _.isEmpty(res.body[0].movil) ? '' : res.body[0].movil
                let barrio = _.isEmpty(res.body[0].barrio) ? '' : res.body[0].barrio
                let direccion = _.isEmpty(res.body[0].direccion) ? '' : res.body[0].direccion
                let ocupacion = _.isEmpty(res.body[0].profesion) ? '' : res.body[0].profesion
                let ciudad = _.isEmpty(res.body[0].ciudad) ? '' : res.body[0].ciudad
                let endpoint = `https://core.sicor.com.co:9000/${res.body[0].imagenId}`
                request
                .get(endpoint)
                .set('Authorization', `Bearer ${getToken()}`)
                .use(NoCache)
                // .set('Accept', 'application/json')
                .end((err, res) => {
                  if (err) throw (err)
                  this.setState({patientImage: res.text, imagePreviewUrl: res.text})
                })
                this.setState({
                  loader: 'hide',
                  classForm: 'form-person-info',
                  model: {
                    numeroDocumento: res.body[0].identificacion,
                    nombres: res.body[0].nombres,
                    apellidos: res.body[0].apellidos,
                    email: email,
                    tipoDocumento: this.tipoDocumentoProcess(res.body[0].tipo_identificacion),
                    telefono: telefono,
                    celular: celular,
                    direccion: direccion,
                    barrio: barrio,
                    ocupacion: ocupacion,
                    ciudad: ciudad,
                    estadoCivil: this.estadoCivilProcess(res.body[0].estado_civil),
                    fechaNacimiento: (res.body[0].fecha_nacimiento),
                    nivelEducativo: 'preescolar'
                  },
                  isUpdate: false,
                  eps: this.EPSProcess(res.body[0].entidad_remitente),
                  grupo: this.GrupoProcess(res.body[0].nombre),
                  type: this.tipoAfiliacionProcess(res.body[0].tipo_afiliacion),
                  selectedGender: gender
                })
                // TODO: intento hacer un verificar de el modelo.
              }
            }
          })
        }
      })
    } else {
      this.setState({
        loader: 'hide',
        classForm: 'form-person-info'
      })
    }
  }

  imageUpload (event) {
    // let picture = document.getElementById('photo')
    let reader = new FileReader()
    let file = event.target.files[0]
    let megas = (file.size / 1048576)
    if (megas > 2) {
      this.refs.container.error('Tamaño de la foto exede el limite permitido (2 Megabytes)', '', {
        closeButton: true
      })
    } else {
      let src = window.URL.createObjectURL(event.target.files[0])
      this.setState({patientImage: src})
      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        })
      }
      reader.readAsDataURL(file)
    }
  }

  saveSpecial (special) {
    this.setState({marcaciones: special})
  }

  handleChange (date) {
    this.setState({ date: new Date() })
  }

  uploadPicture (event) {
    let picture = document.getElementById('photo')
    picture.src = window.URL.createObjectURL(event.target.files[0])
  }

  showGuardian (changeEvent) {
    if (changeEvent.target.value === 'Y') {
      this.setState({ selectedValue: changeEvent.target.value, showGuardianFields: true })
    } else {
      this.setState({ selectedValue: changeEvent.target.value, showGuardianFields: false })
    }
  }

  chooseGender (changeEvent) {
    this.setState({ selectedGender: changeEvent.target.value })
  }

  isValidEmailAddress (emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
    return pattern.test(emailAddress)
  }

  numeroDocumentoFind (value) {
    if (value.length > 4) {
      let url = `/api/v1/patient/numeroDocumento/${value}`
      request
        .get(url)
        .set('Authorization', 'Bearer ' + getToken())
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err) {
            err
          } else if (!_.isEmpty(res.body)) {
            this.refs.container.warning(<span className='center-content'>La identificación que ingreso pertenece a otro paciente ¿Desea regresar al listado y buscar el paciente? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.searchRedirect.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear' onClick={this.identificationEmpty.bind(this)}>No</button></span></span>, <em>Identificación existente</em>, {
              closeButton: true,
              'showDuration': '300',
              'hideDuration': '1000',
              'timeOut': 0,
              'extendedTimeOut': 0,
              'showEasing': 'swing',
              'hideEasing': 'linear',
              'showMethod': 'fadeIn',
              'hideMethod': 'fadeOut'
            })
          }
        })
    }
  }

  emailValidation (value) {
    if (this.isValidEmailAddress(value)) {
      let url = `api/v1/patient/email/${value}`
      request
        .get(url)
        .set('Authorization', 'Bearer ' + getToken())
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err) {
            err
          } else if (!_.isEmpty(res.body)) {
            this.refs.container.warning(<span className='center-content'>El email ingresado está siendo usado por otro paciente ¿Desea usarlo de todos modos? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear'>Si</button><button type='button' className='btn btn-confirm clear' onClick={this.emailEmpty.bind(this)}>No</button></span></span>, <em>Email en uso</em>, {
              closeButton: true,
              'showDuration': '300',
              'hideDuration': '1000',
              'timeOut': 0,
              'extendedTimeOut': 0,
              'showEasing': 'swing',
              'hideEasing': 'linear',
              'showMethod': 'fadeIn',
              'hideMethod': 'fadeOut'
            })
          }
        })
    }
  }

  handleOptionChangeGroup (changeEvent) {
    // invalid-field
    this.setState({ grupo: changeEvent.target.value, groupClass: changeEvent.target.value ? 'select list' : 'select list invalid-field' })
  }
  handleOptionChangeType (changeEvent) {
    this.setState({ type: changeEvent.target.value, typeClass: changeEvent.target.value ? 'select list' : 'select list invalid-field' })
  }
  handleOptionChangeEps (changeEvent) {
    this.setState({ eps: changeEvent.target.value, epsClass: changeEvent.target.value ? 'select list' : 'select list invalid-field' })
  }
  showTextBox (val) {
    this.setState({marcaciones: val})
  }

  emailEmpty () {
    let newModel = _.extend({}, this.state.model)
    newModel.email = ''
    this.setState({ model: newModel })
  }

  identificationEmpty () {
    let newModel = _.extend({}, this.state.model)
    newModel.numeroDocumento = ''
    this.setState({ model: newModel })
  }

  savePatient (formValue) {
    let model = this.state.model
    model.genero = this.state.selectedGender
    model.image = this.state.imagePreviewUrl
    console.log(model.image)
    let patient = _.merge(model, this.state.marcaciones)
    patient.grupo = this.state.grupo
    patient.eps = this.state.eps
    patient.type = this.state.type
    let endpoint = 'api/v1/patient/'
    if (this.state.isUpdate === true) {
      request
      .put(endpoint)
      .use(NoCache)
      .set('Authorization', `Bearer ${getToken()}`)
      .send(patient)
      .end((err, res) => {
        // if (res.statusCode === 200) {
        //   // TODO: Manejar el estado con una accion
        // }
        if (err || !res.ok) {
          this.refs.container.error('No se pudo Actualizar el paciente', '', {
            closeButton: true
          })
        } else {
          this.refs.container.success('El paciente se actualizó satisfactoriamente', '', {
            closeButton: true
          })
          setTimeout(() => { hashHistory.push('search') }, 3000)
        }
      })
    } else {
      let endpoint = 'api/v1/patient/register'
      request
         .post(endpoint)
         .use(NoCache)
         .set('Authorization', 'Bearer ' + getToken())
         .send(patient)
         .set('Accept', 'application/json')
         .end((err, res) => {
           if (err || !res.ok) {
             this.refs.container.error('No se pudo registrar el paciente', '', {
               closeButton: true
             })
           } else {
             this.refs.container.success('El paciente se registró satisfactoriamente', '', {
               closeButton: true
             })
             setTimeout(() => { hashHistory.push('search') }, 3000)
           }
         })
    }
  }

  searchRedirect () {
    hashHistory.push('search')
  }

  cancelFunction (e) {
    e.preventDefault()
    if (this.state.dirty === true) {
      this.refs.container.warning(<span className='center-content'>Tiene cambios pendientes ¿Desea regresar al Listado de todos modos? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.searchRedirect.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear'>No</button></span></span>, <em>Tiene cambios pendientes</em>, {
        closeButton: true,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': 0,
        'extendedTimeOut': 0,
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      })
    } else {
      this.searchRedirect()
    }
  }

  findData () {
    request
    .get('api/v1/patient/select/')
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, result) => {
      if (result) {
        let grupos_ = result.body.group
        let eps_ = result.body.eps
        let types_ = result.body.type
        this.setState({'grupos': grupos_, 'epsSelect': eps_, 'types': types_})
      } else {
        if (err) {
          err
        }
      }
    })
  }
  render () {
    var cOptionsGrupos
    if (!_.isEmpty(this.state.grupos)) {
      let arrayElements = this.state.grupos
      cOptionsGrupos = arrayElements.map(function (item, index) {
        return <option value={item._id}>{item.nombre}</option>
      })
    }
    var cOptionsEps
    if (!_.isEmpty(this.state.epsSelect)) {
      let arrayElements = this.state.epsSelect
      cOptionsEps = arrayElements.map(function (item, index) {
        return <option value={item._id}>{item.nombre}</option>
      })
    }
    var cOptionsType
    if (!_.isEmpty(this.state.types)) {
      let arrayElements = this.state.types
      cOptionsType = arrayElements.map(function (item, index) {
        return <option value={item._id}>{item.nombre}</option>
      })
    }
    return (
      <div className='main-information-container'>
        <NavigationBar dirty={this.state.dirty}/>
        <div className='registration-container-patient'>
          <div className='patient-profile'>
            <div className={this.state.loader}>
              <div className='loader'>
              </div>
            </div>
            <Form className={this.state.classForm} schema={patientSchema} value={this.state.model} onChange={model => this.setState({ model, dirty: true })}>
              <ProfilePicture imageUpdate={this.loadImage.bind(this)} image={this.imageUpload.bind(this)} data={this.state.patientImage}/>
              <div className='person-info-container'>
                <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
                <div className='person-data-fields person-left-container'>
                  <div className='flex'>
                    <div className='form-group'>
                      <Form.Field type='select' name='tipoDocumento' id='tipoDocumento' ref='tipoDocumento' className='select'>
                        <option value={null}>Documento</option>
                        <option value='CC'>CC</option>
                        <option value='CE'>CE</option>
                        <option value='PP'>PP</option>
                        <option value='TI'>TI</option>
                        <option value='RC'>RC</option>
                      </Form.Field>
                    </div>
                    <div className='form-group'>
                      <Form.Field name='numeroDocumento' id='numeroDocumento' ref='numeroDocumento' className='form-input form-input-id' placeholder='Número de Identificación' onChange={this.numeroDocumentoFind.bind(this)}/>
                    </div>
                  </div>
                  <div className='form-group'>
                    <Form.Message className='message' for='tipoDocumento' />
                    <Form.Message className='message' for='numeroDocumento'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='nombres' id='nombres' ref='nombres' className='form-input' placeholder='Nombre Completo'/>
                    <Form.Message className='message' for='nombres'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='apellidos' id='apellidos' className='form-input' ref='apellidos' placeholder='Apellidos'/>
                    <Form.Message className='message' for='apellidos'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='email' id='email' className='form-input' ref='email' placeholder='Email' onChange={this.emailValidation.bind(this)} />
                    <Form.Message className='message' for='email'/>
                  </div>
                  <div className='form-group'>
                    <div className='gender-container'>
                      <input id='sex_f' ref='sex_f' name='gender' type='radio' value='f' className='register-switch-input' checked={this.state.selectedGender === 'f'} onChange={this.chooseGender.bind(this)} />
                      <label htmlFor='sex_f' className='register-switch-label'>Mujer</label>
                      <input id='sex_m' ref='sex_m' name='gender' type='radio' value='m' className='register-switch-input' checked={this.state.selectedGender === 'm'} onChange={this.chooseGender.bind(this)} />
                      <label htmlFor='sex_m' className='register-switch-label'>Hombre</label>
                    </div>
                  </div>
                  <div className='flex'>
                    <div className='form-group'>
                      <Form.Field name='telefono' id='telefono' className='form-input form-input-phone form-input-phone-left' ref='telefono' placeholder='Teléfono'/>
                    </div>
                    <div className='form-group'>
                      <Form.Field name='celular' id='celular' className='form-input form-input-phone' ref='celular' placeholder='Celular'/>
                    </div>
                  </div>
                  <div className='form-group'>
                    <Form.Message className='message' for='telefono' />
                    <Form.Message className='message' for='celular'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='direccion' id='direccion' ref='direccion' className='form-input' placeholder='Dirección'/>
                    <Form.Message className='message' for='direccion'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='barrio' id='barrio' ref='barrio' className='form-input' placeholder='Barrio'/>
                    <Form.Message className='message' for='barrio'/>
                  </div>
                </div>
                <img className='middleline middleline-patient' src={MiddleLine} />
                <div className='person-data-fields'>
                  <div className='form-group'>
                    <Form.Field name='ciudad' id='ciudad' ref='ciudad' className='form-input' placeholder='Ciudad'/>
                    <Form.Message className='message' for='ciudad'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='ocupacion' id='ocupacion' ref='ocupacion' className='form-input' placeholder='Ocupación'/>
                    <Form.Message className='message' for='ocupacion'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field type='select' name='estadoCivil' id='estadoCivil' ref='estadoCivil' className='select list'>
                      <option value={null}>Estado civil</option>
                      <option value='Soltero'>Soltero</option>
                      <option value='Unión libre'>Unión libre</option>
                      <option value='Casado'>Casado</option>
                      <option value='Divorciado'>Divorciado</option>
                      <option value='Viudo'>Viudo</option>
                    </Form.Field>
                    <Form.Message className='message' for='estadoCivil'/>
                  </div>
                  <div className='form-group'>
                    <select type='select' name='entidad' id='entidad' ref='entidad' className={this.state.epsClass} value={this.state.eps} onChange={this.handleOptionChangeEps.bind(this)}>
                      <option value={''}>Entidad Médica</option>
                      {cOptionsEps}
                    </select>
                    { (_.isEmpty(this.state.eps) || this.state.eps === 'null') ? <span className='message validation-error' >Seleccione la entidad médica</span> : '' }
                  </div>
                  <div className='form-group'>
                    <select name='grupo' id='grupo' ref='grupo' className={this.state.groupClass} value={this.state.grupo} onChange={this.handleOptionChangeGroup.bind(this)}>
                      <option value={''}>Grupo al que pertenece</option>
                      {cOptionsGrupos}
                    </select>
                    { (_.isEmpty(this.state.grupo) || this.state.grupo === 'null') ? <span className='message validation-error' >Seleccione un grupo</span> : '' }
                  </div>
                  <div className='form-group'>
                    <select type='select' name='tipoAfiliacion' id='tipoAfiliacion' ref='tipoAfiliacion' className={this.state.typeClass} value={this.state.type} onChange={this.handleOptionChangeType.bind(this)}>
                      <option value={''}>Tipo de Afiliación</option>
                      {cOptionsType}
                    </select>
                    { (_.isEmpty(this.state.type)) ? <span className='message validation-error' >Seleccione un tipo de afiliación</span> : '' }
                  </div>
                  <div className='form-group'>
                    <Form.Field type='text' name='fechaNacimiento' id='fechaNacimiento' ref='fechaNacimiento' className='form-input' placeholder='Fecha de nacimiento (DD/MM/AAAA)'/>
                    <Form.Message className='message' for='fechaNacimiento'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field type='select' name='nivelEducativo' id='nivelEducativo' ref='nivelEducativo' className='select list'>
                      <option value={null}>Nivel educativo</option>
                      <option value='preescolar'>Educación preescolar</option>
                      <option value='primaria'>Educación primaria</option>
                      <option value='secundaria'>Educación secundaria</option>
                      <option value='media'>Educación media</option>
                      <option value='universitaria'>Educación universitaria</option>
                    </Form.Field>
                    <Form.Message className='message' for='nivelEducativo'/>
                  </div>
                </div>
              </div>
              <div className='person-info-container person-data-fields-down marc-container'>
                <div className='person-data-fields person-left-container marc-conditions'>
                  <div className='guardian-container'>
                    <span>Acompañante</span>
                    <div className='yesno-container'>
                      <input id='yes' ref='yesinput' name='yesno' type='radio' value='Y' className='yesno-switch-input' checked={this.state.selectedValue === 'Y'} onChange={this.showGuardian.bind(this)} />
                      <label id='yesAc' htmlFor='yes' className='yesno-switch-label'>Si</label>
                      <input id='no' ref='notinput' name='yesno' type='radio' value='N' className='yesno-switch-input' checked={this.state.selectedValue === 'N'} onChange={this.showGuardian.bind(this)} />
                      <label id='noAc'  htmlFor='no' className='yesno-switch-label'>No</label>
                    </div>
                  </div>
                </div>
                <div className='person-data-fields'>
                  <SpecialConditions onSaveSpecial={this.saveSpecial.bind(this)} showTextBoxParent={this.showTextBox.bind(this)} data={this.props.patientId}/>
                </div>
              </div>
               { this.state.showGuardianFields ?
                 <div id='guardian-data' className='person-info-container person-data-fields-down'>
                   <div className='person-data-fields person-left-container'>
                     <div className='form-group'>
                       <Form.Field name='parentezco' id='parentezco' className='form-input' ref='parentezco' placeholder='Parentesco'/>
                       <Form.Message className='message' for='parentezco'/>
                     </div>
                     <div className='flex'>
                       <div className='form-group'>
                         <Form.Field type='select' name='tipoDocumentoAcomp' id='tipoDocumentoAcomp' ref='tipoDocumentoAcomp' className='select'>
                           <option value={null}>Documento</option>
                           <option value='CC'>CC</option>
                           <option value='CE'>CE</option>
                           <option value='PP'>PP</option>
                           <option value='TI'>TI</option>
                           <option value='RC'>RC</option>
                         </Form.Field>
                       </div>
                       <div className='form-group'>
                         <Form.Field name='numeroDocumentoAcomp' id='numeroDocumentoAcomp' ref='numeroDocumentoAcomp' className='form-input form-input-id' placeholder='Número de Identificación' onChange={this.numeroDocumentoFind.bind(this)}/>
                       </div>
                     </div>
                     <div className='form-group'>
                       <Form.Message className='message' for='tipoDocumentoAcomp' />
                       <Form.Message className='message' for='numeroDocumentoAcomp'/>
                     </div>
                     <div className='form-group'>
                       <Form.Field name='nombresAcomp' id='nombresAcomp' ref='nombresAcomp' className='form-input' placeholder='Nombre Completo'/>
                       <Form.Message className='message' for='nombresAcomp'/>
                     </div>
                     <div className='form-group'>
                       <Form.Field name='apellidosAcomp' id='apellidosAcomp' className='form-input' ref='gapellidos' placeholder='Apellidos'/>
                       <Form.Message className='message' for='apellidosAcomp'/>
                     </div>
                   </div>
                   <img className='guardian-line' src={MiddleLine} />
                   <div className='person-data-fields'>
                     <div className='form-group'>
                       <Form.Field name='telefonoAcomp' id='telefonoAcomp' ref='telefonoAcomp' className='form-input' placeholder='Télefono'/>
                       <Form.Message className='message' for='telefonoAcomp'/>
                     </div>
                     <div className='form-group'>
                       <Form.Field name='celularAcomp' id='celularAcomp' className='form-input' ref='celularAcomp' placeholder='Celular'/>
                       <Form.Message className='message' for='celularAcomp'/>
                     </div>
                   </div>
                 </div>
                 : null
               }
               <div className='form-submit-btn-container'>
                 <button id='cancelSquares' className='form-submit-button save-button' onClick={this.cancelFunction.bind(this)}>⟵ Regresar</button>
                 {this.state.muerto ? '' : <Form.Button type='submit' id='saveData' className='form-submit-button save-button' onClick={this.savePatient.bind(this)}>Guardar</Form.Button>}
               </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/PatientForm.js